export default __webpack_public_path__ + "img/eYSjAXPN.e9fc8d30.svg";